export default __webpack_public_path__ + "static/Bear_Trap-bfe5970c99a6f7ff4533ec2f8d9b3fb7.png";